import type { ReactNode } from 'react';

interface ScaffoldProps {
  appBar?: ReactNode;
  body: ReactNode;
}

/**
 * Scaffold — page shell. Owns the viewport height, paper background
 * and column flow; the optional `appBar` slot sits on top and the
 * `body` slot fills the remaining height with its own scroll. Sized
 * with `min-w-0 flex-1` so it works both as a top-level page and as a
 * sidebar-adjacent column (e.g. settings shell, where `Sidebar` claims
 * the rail and `Scaffold` claims the rest).
 */
export function Scaffold({ appBar, body }: Readonly<ScaffoldProps>): React.JSX.Element {
  return (
    <div className="flex h-full min-w-0 flex-1 flex-col bg-paper">
      {appBar}
      <main className="flex min-h-0 flex-1 flex-col overflow-auto px-8 py-7">{body}</main>
    </div>
  );
}
